export class DataSilo {
    constructor(endpoint, project) {
        endpoint = endpoint.trim();

        if (endpoint.slice(-1) === '/') {
            endpoint = endpoint.slice(0, -1);
        }

        this.endpoint = endpoint;
        this.project = project;
    }

    async get(uid) {
        const url = `${this.endpoint}/${this.project}/${uid}`;
        const req = await window.fetch(url);

        if (req.status === 200) {
            return await req.json();
        } else {
            throw new Error('Could not get data');
        }
    }

    async post(data) {
        const url = `${this.endpoint}/${this.project}`;
        const req = await window.fetch(url, {
            method : 'POST',
            body : JSON.stringify(data)
        });
        const res = await req.json();
        return res.uid;
    }
}